import { Button } from 'antd'
import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoItemsTitle = styled.h4`
  font-weight: 500;
  font-size: 18px;
  line-height: 1.3;
  color: ${COLORS.text.default};

  margin: 16px 0 8px;
`

export const NoItemsDescription = styled.p`
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
  color: #696b7b;
`

export const JoinButton = styled(Button)`
  width: 176px;
  margin-top: 24px;
`
